import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";

import { useForm, Controller } from "react-hook-form";


import { updateFilesRechazados, updateObjectFilesupd } from '../../slices/vendor/vendorThunks';
import { instanceAxiosPrivate } from '../../axios';
import LoadingPortal from '../loadings/LoadingPortal';

const UploadFile = (props) => {
    
    const dispatch = useDispatch()
    const { loading } = useSelector((state) => state.form_vendor);
    const file = useRef({});

    const { perfil } = useSelector((state) => state.user);

    const { data, rechazo } = props;
    const [mensajes, setMensajes] = useState([]);
   

    const { 
        register,
        control,
        handleSubmit,
        setValue,
    } = useForm({});

    const onSubmit = async (values) => {
    //send to adrive and upd state
    let info = {
        iddir: data.iddir,
        user_id: perfil.user_id
    }        
    dispatch(updateFilesRechazados(info))
    }

    const handleChangeFile = async (e) => {
        // selection file
        const file = e.target.files[0];
        // set file on window
        const instA = new instanceAxiosPrivate();
        instA.setItemGeneral(`iddir_${data.iddir}`, file);

        if(file){
            setValue(`iddir_${data.iddir}`, instA.getItemGeneral(`iddir_${data.iddir}`)); 
        }

        dispatch(updateObjectFilesupd({
            iddir: data.iddir,
            name_dir: data.name_dir,
            name_file: file.name,
            mime: 31,
            size: file.size,
            type_document: 1
        }))
    }
    
    useEffect(() => {
        try {
            let array = JSON.parse(rechazo) || [] ;
            setMensajes(array);
        } catch (error) {
            console.log(error)
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) 
    

    return (
        <div 
        className={'card card-danger card-outline p-3'}
        >
            { loading ? (<LoadingPortal isOpen={loading} />): ''}
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='col-12 col-md-12 px-2'>
                    <label className='text-capitalize'>
                        {data.name_dir}
                    </label>
                    <Controller
                        name={`iddir_${data.iddir}`}
                        control={control}
                        render={({ field: { value, onChange, ...field } }) => (
                            <input
                                type="file" 
                                {...field}
                                {...register(`iddir_${data.iddir}`)}
                                id={`iddir_${data.iddir}`}
                                value={value?.fileName}
                                ref={file}
                                accept="application/pdf"
                                onChange={ (event) => {handleChangeFile(event)} }
                                className="form-control"
                            />
                        )}
                    />
                   { mensajes.length > 0
                    ? (<ul>
                        {mensajes.map((mensaje, index) => (
                            <li key={index} className='text-red text-break font-weight-bold' style={{fontSize: '14px'}}>{mensaje}</li>
                        ))}
                    </ul>)
                    : <span className='text-red text-break font-weight-bold' style={{fontSize: '14px'}}>Actualización de documento</span> 
                   } 
                    
                </div>
                <div className='col-12 col-md-12 px-2 mt-2'>
                    <button type='button' className='btn btn-danger float-right' onClick={handleSubmit(onSubmit)}>Cargar</button>   
                </div>
            </form>
        </div>
    )
}

export default UploadFile